import React from 'react';
import css from './css.module.less';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import { QuestionCircleFilled } from '@ant-design/icons';

const Tip = (props) => {
  const { title, content, overlayDescription } = props;
  return (
    <div className={css.container}>
      <div className={css.title}>
        <span className={css.name}>{title}</span>
        {overlayDescription ? (
          <WhiteBackgroundTooltip
            overlayClassName={css.overlayClassName}
            title={
              <TooltipContainer>
                <TooltipContent>{overlayDescription}</TooltipContent>
              </TooltipContainer>
            }
            placement='rightTop' //overlayClassName
          >
            <QuestionCircleFilled className={css.icon} />
          </WhiteBackgroundTooltip>
        ) : (
          <></>
        )}
      </div>
      <div className={css.content}>{content}</div>
    </div>
  );
};
export default Tip;
